import { combineReducers } from 'redux'
import changelog from './changelog'
import sidebar from './sidebar'
import agenda from './agenda'
import auth from './auth'

const REDUCERS = { auth, changelog, sidebar, agenda }

export default combineReducers(REDUCERS)
